export default __webpack_public_path__ + "images/0c8b1a4589d52260b9db24714b5b91d7-greeting-pyxir.svg";